<template>
  <DashboardCard
    class="big-number-card"
    :title="title"
    :working="loading"
    :showLink="!!route"
    @link="$router.push(route)"
  >
    <v-tooltip open-delay="500" top color="white">
      <template v-slot:activator="{ on }">
        <v-container class="fill-height" v-on="on">
          <v-row align="center" justify="center" class="fill-height">
            <v-col 
              cols="12" 
              class="px-0 text-no-wrap text-center text-truncate" 
              style="vertical-align:middle;font-size:75px"
            >
              <v-icon 
                style="vertical-align:baseline" 
                left 
                size="50px" 
                class="px-0"
              >
              {{icon}}
              </v-icon>{{value}}
            </v-col>
            <v-col cols="12">
              <div 
                class="text-truncate text-nowrap text-center" 
                style="font-size:14px"
              >
                {{subtitle}}
              </div>
            </v-col>
          </v-row>      
        </v-container>      
      </template>
      <div v-html="tooltip"></div>
    </v-tooltip>        
  </DashboardCard>
</template>
<script>
import { DashboardCard } from '@itus/ui.common'

export default {
  name: 'CountCard',
  props: {
    value: String,
    icon: String,
    title: String,
    subtitle: String,
    tooltip: String,
    route: String,
    loading: Boolean
  },
  components: {
    DashboardCard
  }
}
</script>
<style scoped>
.big-number-card {
  height:200px;
}
.v-tooltip__content {
  color: var(--v-primary-base);
  opacity: 0.9 !important;
  border: 1px solid var(--v-primary-base) !important; 
  max-width: 400px;
}
</style>